import Vue from 'vue';
import { isProd, env } from '@shared/env';

Vue.prototype.$isProd = isProd;
Vue.prototype.$env = env;
